export interface ContactCandidate {
	readonly id: string
	readonly name: string
	readonly email: string
	readonly phone?: string | null
	readonly source?: string
}

export type ContactFormMode = 'add' | 'edit'

export type ContactDraft = {
	id?: string
	title: string
	name: string
	email: string
	phone: string
}

export function createEmptyContactDraft(): ContactDraft {
	return {
		id: undefined,
		title: '',
		name: '',
		email: '',
		phone: '',
	}
}

export function toContactDraft(candidate: ContactCandidate): ContactDraft {
	return {
		id: candidate.id,
		title: '',
		name: candidate.name ?? '',
		email: candidate.email ?? '',
		phone: candidate.phone ?? '',
	}
}
